<div class="toolbar-count">
    <table class="table-bordered">
        <tbody>
            <tr>
                <td><fa-icon [icon]="faTable"></fa-icon></td>
                <td>{{ grid.itemCount.toLocaleString() }}/{{ grid.itemTotalCount.toLocaleString() }}</td>
            </tr>
        </tbody>
    </table>
</div>
